"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareConvo = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
require("@front/components/gen-image/component");
const download_helper_1 = require("@front/helpers/download.helper");
const voucher_code_generator_1 = __importDefault(require("voucher-code-generator"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="share-conversation-container">
    
    <div class="loading-container" ?hidden="${x => !x.loading}">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">${'loading'.t()}</span>
        </div>
        <p class="loading-text">${'share.conversation.loading'.t()}</p>
    </div>

    
    <div class="error-container" ?hidden="${x => !x.error}">
        <div class="alert alert-danger" role="alert">
            <i class="simple-icon-exclamation me-2"></i>
            ${x => x.error}
        </div>
        <div class="error-actions">
            <button type="button" class="btn btn-primary" @click="${x => x.goToChat()}">
                <i class="simple-icon-bubble me-2"></i>
                ${'share.conversation.goToChat'.t()}
            </button>
        </div>
    </div>

    
    <div class="conversation-content" ?hidden="${x => x.loading || !!x.error}">
        
        <div class="conversation-header">
            <div class="conversation-info">
                <h1 class="conversation-title">
                    <i class="simple-icon-share me-2"></i>
                    ${x => x.conversationTitle}
                </h1>
                <div class="conversation-meta" ?hidden="${x => !x.conversation}">
                    <span class="conversation-date">
                        <i class="simple-icon-calendar me-1"></i>
                        ${x => {
    var _a;
    return ((_a = x.conversation) === null || _a === void 0 ? void 0 : _a.created_at) ? new Date(x.conversation.created_at).toLocaleDateString() :
        '';
}}
                    </span>                  
                </div>
            </div>
            <div class="conversation-actions">
                <button type="button" class="btn btn-outline-primary" @click="${x => x.copyConversationLink()}"
                    title="${'share.conversation.copyLink'.t()}">
                    <i class="simple-icon-docs me-2"></i>
                    ${'share.conversation.copyLink'.t()}
                    <span class="ml-1 copy-feedback" ?hidden="${x => !x.copied}"><i class="simple-icon-check"></i></span>
                </button>
            </div>
        </div>

        
        <div class="messages-container" ?hidden="${x => x.messages.length === 0}">
            <div class="message-list">
                ${(0, fast_element_1.repeat)(x => x.messages, (0, fast_element_1.html) `
                <div class="message-wrapper ${x => x.isUserMessage ? 'user-message' : 'assistant-message'}">
                    <div class="message-avatar">
                        ${(0, fast_element_1.when)(x => x.isUserMessage, (0, fast_element_1.html) `<img class="user-avatar" alt="${x => x.user.name}"
                            src="${x => x.user.profile_pic ? (('/uploads/' + x.user.profile_pic.filename).thumb('square-small')) : '/assets/images/avatar.jpg'}" />`, (0, fast_element_1.html) `<i class="simple-icon-screen-desktop"></i>`)}
                    </div>
                    <div class="message-content">
                        <div class="message-header">
                            <span class="message-author">
                                ${x => x.isUserMessage ? (x.user.name && x.user.last_name ? `${x.user.name} ${x.user.last_name}` : x.user.username) :
    'share.conversation.assistant'.t()}
                            </span>
                            <span class="message-timestamp">
                                ${x => new Date(x.timestamp).toLocaleString()}
                            </span>
                            <span class="message-model" ?hidden="${x => !x.model}">
                                ${x => x.model}
                            </span>
                        </div>
                        <div class="message-body">
                            <div class="message-thoughts" ?hidden="${x => !x.thoughts}">
                                <details>
                                    <summary>${'share.conversation.thoughts'.t()}</summary>
                                    <p>${x => x.thoughts}</p>
                                </details>
                            </div>
                            <div class="message-files" ?hidden="${x => !x.files || x.files.length === 0}">
                                ${(0, fast_element_1.repeat)(x => x.files, (0, fast_element_1.html) `
                                <div class="file-item">
                                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.mimeType) === null || _a === void 0 ? void 0 : _a.startsWith('image/'); }, (0, fast_element_1.html) `
                                    <gen-image fileId="${x => x.id}"
                                        imageFormat="${x => x.mimeType ? x.mimeType.split('/')[1] || 'png' : 'png'}"></gen-image>
                                    `, (0, fast_element_1.html) `
                                    <file-card fileId="${x => x.id}" showDownload="true"></file-card>
                                    `)}
                                </div>
                                `)}
                            </div>
                            <div class="message-text">
                                ${(0, fast_element_1.repeat)(x => x.text, (0, fast_element_1.html) `<p :innerHTML="${x => x.value}"></p>`)}
                            </div>
                            <div class="message-citations" ?hidden="${x => !x.citations || x.citations.length === 0}">
                                <h6>${'share.conversation.sources'.t()}:</h6>
                                <ul>
                                    ${(0, fast_element_1.repeat)(x => x.citations, (0, fast_element_1.html) `
                                    <li>[${x => x.ref}] ${x => x.text}</li>
                                    `)}
                                </ul>
                            </div>
                            <div class="message-tools" ?hidden="${x => !x.tools || x.tools.length === 0}">
                                <h6>${'share.conversation.toolsUsed'.t()}:</h6>
                                <ul>
                                    ${(0, fast_element_1.repeat)(x => x.tools, (0, fast_element_1.html) `<li>${x => x.toolName}</li>`)}
                                </ul>
                            </div>
                            <div class="message-error alert alert-danger" ?hidden="${x => !x.error}">
                                <i class="simple-icon-exclamation me-2"></i>
                                ${x => { var _a; return (_a = x.error) === null || _a === void 0 ? void 0 : _a.message; }}
                            </div>
                        </div>
                    </div>
                </div>
                `)}
            </div>
        </div>

        
        <div class="empty-state" ?hidden="${x => x.messages.length > 0}">
            <div class="empty-state-content">
                <i class="simple-icon-bubble empty-state-icon"></i>
                <h3>${'share.conversation.noMessages'.t()}</h3>
                <p>${'share.conversation.noMessagesDescription'.t()}</p>
            </div>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.share-conversation-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 0;
}
.share-conversation-container .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 1rem;
}
.share-conversation-container .loading-container .loading-text {
  color: #6c757d;
  font-size: 1.1rem;
  margin: 0;
}
.share-conversation-container .error-container {
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
}
.share-conversation-container .error-container .error-actions {
  margin-top: 1.5rem;
  text-align: center;
}
.share-conversation-container .conversation-content {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  min-height: 100vh;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
.share-conversation-container .conversation-header {
  background: white;
  border-bottom: 1px solid #e9ecef;
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1rem;
}
.share-conversation-container .conversation-header .conversation-info {
  flex: 1;
  min-width: 300px;
}
.share-conversation-container .conversation-header .conversation-info .conversation-title {
  margin: 0 0 0.5rem 0;
  color: #2c3e50;
  font-size: 1.8rem;
  font-weight: 600;
}
.share-conversation-container .conversation-header .conversation-info .conversation-title i {
  color: #3498db;
}
.share-conversation-container .conversation-header .conversation-info .conversation-meta {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}
.share-conversation-container .conversation-header .conversation-info .conversation-meta span {
  color: #6c757d;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.share-conversation-container .conversation-header .conversation-info .conversation-meta .conversation-model {
  background: #e3f2fd;
  color: #1976d2;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-weight: 500;
}
.share-conversation-container .conversation-header .conversation-actions {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}
.share-conversation-container .conversation-header .conversation-actions .btn {
  white-space: nowrap;
}
.share-conversation-container .messages-container {
  padding: 0;
}
.share-conversation-container .messages-container .message-list {
  padding: 1rem 0;
}
.share-conversation-container .message-wrapper {
  display: flex;
  padding: 1rem 2rem;
  gap: 1rem;
  border-bottom: 1px solid #f8f9fa;
}
.share-conversation-container .message-wrapper.user-message {
  background: #f8f9ff;
}
.share-conversation-container .message-wrapper.user-message .message-avatar {
  background: #3498db;
  color: white;
}
.share-conversation-container .message-wrapper.user-message .message-avatar .user-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.share-conversation-container .message-wrapper.assistant-message {
  background: white;
}
.share-conversation-container .message-wrapper.assistant-message .message-avatar {
  background: #2ecc71;
  color: white;
}
.share-conversation-container .message-wrapper .message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.1rem;
}
.share-conversation-container .message-wrapper .message-content {
  flex: 1;
  min-width: 0;
}
.share-conversation-container .message-wrapper .message-content .message-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}
.share-conversation-container .message-wrapper .message-content .message-header .message-author {
  font-weight: 600;
  color: #2c3e50;
}
.share-conversation-container .message-wrapper .message-content .message-header .message-timestamp {
  color: #6c757d;
  font-size: 0.85rem;
}
.share-conversation-container .message-wrapper .message-content .message-header .message-model {
  background: #fff3cd;
  color: #856404;
  padding: 0.125rem 0.375rem;
  border-radius: 3px;
  font-size: 0.8rem;
  font-weight: 500;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-reasoning {
  margin-bottom: 1rem;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-reasoning details {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 0.5rem;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-reasoning details summary {
  cursor: pointer;
  font-weight: 500;
  color: #495057;
  user-select: none;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-reasoning details summary:hover {
  color: #2c3e50;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-reasoning details p {
  margin: 0.5rem 0 0 0;
  color: #6c757d;
  line-height: 1.5;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-text {
  line-height: 1.6;
  color: #2c3e50;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-text p {
  margin: 0 0 0.75rem 0;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-text p:last-child {
  margin-bottom: 0;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-text pre {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 1rem;
  overflow-x: auto;
  font-size: 0.9rem;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-text code {
  background: #f8f9fa;
  color: #e83e8c;
  padding: 0.125rem 0.25rem;
  border-radius: 3px;
  font-size: 0.9em;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-text pre code {
  background: none;
  color: inherit;
  padding: 0;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-citations {
  margin-top: 1rem;
  background: #e7f3ff;
  border-left: 4px solid #2196f3;
  padding: 1rem;
  border-radius: 0 6px 6px 0;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-citations h6 {
  margin: 0 0 0.5rem 0;
  color: #1976d2;
  font-weight: 600;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-citations ul {
  margin: 0;
  padding-left: 1.5rem;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-citations ul li {
  margin-bottom: 0.25rem;
  color: #495057;
  line-height: 1.4;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-tools {
  margin-top: 1rem;
  background: #fff3e0;
  border-left: 4px solid #ff9800;
  padding: 1rem;
  border-radius: 0 6px 6px 0;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-tools h6 {
  margin: 0 0 0.5rem 0;
  color: #f57c00;
  font-weight: 600;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-tools ul {
  margin: 0;
  padding-left: 1.5rem;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-tools ul li {
  margin-bottom: 0.25rem;
  color: #495057;
  font-weight: 500;
}
.share-conversation-container .message-wrapper .message-content .message-body .message-error {
  margin-top: 1rem;
  border-left: 4px solid #dc3545;
}
.share-conversation-container .empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 2rem;
}
.share-conversation-container .empty-state .empty-state-content {
  text-align: center;
  color: #6c757d;
}
.share-conversation-container .empty-state .empty-state-content .empty-state-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}
.share-conversation-container .empty-state .empty-state-content h3 {
  color: #495057;
  margin-bottom: 0.5rem;
}
.share-conversation-container .empty-state .empty-state-content p {
  margin: 0;
  font-size: 1.1rem;
}
.share-conversation-container .conversation-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  padding: 1.5rem 2rem;
}
.share-conversation-container .conversation-footer .footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.share-conversation-container .conversation-footer .footer-content .footer-info {
  flex: 1;
}
.share-conversation-container .conversation-footer .footer-content .footer-info p {
  margin: 0;
  font-size: 0.9rem;
}
.share-conversation-container .conversation-footer .footer-content .footer-actions .btn {
  white-space: nowrap;
}
@media (max-width: 768px) {
  .share-conversation-container .conversation-header {
    padding: 1rem;
    flex-direction: column;
    align-items: stretch;
  }
  .share-conversation-container .conversation-header .conversation-actions {
    justify-content: stretch;
  }
  .share-conversation-container .conversation-header .conversation-actions .btn {
    flex: 1;
  }
  .share-conversation-container .message-wrapper {
    padding: 1rem;
  }
  .share-conversation-container .message-wrapper .message-content .message-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  .share-conversation-container .conversation-footer .footer-content {
    flex-direction: column;
    align-items: stretch;
  }
  .share-conversation-container .conversation-footer .footer-content .footer-actions .btn {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .share-conversation-container .conversation-header .conversation-info .conversation-title {
    font-size: 1.5rem;
  }
  .share-conversation-container .conversation-header .conversation-meta {
    flex-direction: column;
    gap: 0.5rem;
  }
  .share-conversation-container .message-wrapper {
    flex-direction: column;
    gap: 0.75rem;
  }
  .share-conversation-container .message-wrapper .message-avatar {
    align-self: flex-start;
  }
}
.share-conversation-container .message-files {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.share-conversation-container .message-files .file-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
}
.share-conversation-container .message-files .file-item.image-file {
  border: none;
  background: transparent;
}
.share-conversation-container .message-files .file-item.image-file gen-image {
  display: block;
  max-width: 100%;
}
.share-conversation-container .message-files .file-item.image-file gen-image .generated-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}
.share-conversation-container .message-files .file-item.non-image-file {
  padding: 1rem;
}
.share-conversation-container .message-files .file-item.non-image-file .non-image-file {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.share-conversation-container .message-files .file-item.non-image-file .non-image-file .file-item__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: #007bff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
}
.share-conversation-container .message-files .file-item.non-image-file .non-image-file .file-item__info {
  flex: 1;
  min-width: 0;
}
.share-conversation-container .message-files .file-item.non-image-file .non-image-file .file-item__info .file-item__name {
  font-weight: 500;
  color: #333;
  margin-bottom: 0.25rem;
  word-break: break-word;
}
.share-conversation-container .message-files .file-item.non-image-file .non-image-file .file-item__info .file-item__size {
  font-size: 0.875rem;
  color: #666;
}

p.from-rag {
  border-top: 3px solid #F00;
  position: relative;
  padding-top: 25px;
}
p.from-rag::after {
  background-color: #FFF;
  border-radius: 5px;
  content: "RAG";
  position: absolute;
  top: -15px;
  right: 10px;
  padding: 3px;
  border: 1px solid #F00;
}

p.from-ai-network {
  border-top: 3px solid #0F0;
  position: relative;
  padding-top: 25px;
}
p.from-ai-network::after {
  background-color: #FFF;
  border-radius: 5px;
  content: "AI";
  position: absolute;
  top: -15px;
  right: 10px;
  padding: 3px;
  border: 1px solid #0F0;
}`;
const shadowOptions = { "mode": "open" };
let ShareConvo = class ShareConvo extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.uid = '';
        this.loading = false;
        this.error = '';
        this.conversation = null;
        this.messages = [];
        this.conversationTitle = '';
        this.copied = false;
        this.supportedLanguages = new Set([
            'javascript', 'js', 'typescript', 'ts', 'python', 'py', 'java', 'c', 'cpp', 'c++',
            'csharp', 'cs', 'php', 'ruby', 'go', 'rust', 'swift', 'kotlin', 'scala',
            'html', 'css', 'scss', 'sass', 'json', 'xml', 'yaml', 'yml', 'sql',
            'bash', 'sh', 'shell', 'powershell', 'cmd', 'dockerfile', 'docker',
            'markdown', 'md', 'text', 'plaintext', 'diff', 'git', 'makefile',
            'r', 'matlab', 'perl', 'lua', 'haskell', 'clojure', 'erlang', 'elixir'
        ]);
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.uid) {
            this.loadSharedConversation();
        }
        else {
            this.error = 'share.conversation.noIdProvided'.t();
        }
    }
    getBody() {
        return document.querySelector('body');
    }
    getPreloader() {
        return document.querySelector('#preloader');
    }
    togglePreloader() {
        const preloader = this.getPreloader();
        if (preloader.classList.contains('hidden')) {
            preloader.classList.remove('hidden');
        }
        else {
            preloader.classList.add('hidden');
        }
    }
    async loadSharedConversation() {
        if (!this.uid) {
            this.error = 'share.conversation.noIdProvided'.t();
            return;
        }
        this.loading = true;
        this.error = '';
        try {
            const response = await this.apiService.back.get('conversation.share', { routeParams: { uid: this.uid } });
            if (response && response.success && response.data) {
                this.conversation = response.data.conversation;
                this.conversationTitle = this.conversation.title || 'share.conversation.untitled'.t();
                this.messages = response.data.messages.map(msg => {
                    const replacetool = this.getFullTextPattern();
                    const msgText = msg.text[0].value;
                    let paintedText = msgText.replace(replacetool.pattern, replacetool.replacement);
                    // Replace \n with <br/> only outside of code blocks
                    paintedText = this.replaceLineBreaksOutsideCodeBlocks(paintedText);
                    const painted = { ...msg, text: [{ value: paintedText }] };
                    return painted;
                }) || [];
                this.togglePreloader();
            }
            else {
                this.error = (response === null || response === void 0 ? void 0 : response.error) || 'share.conversation.failedToLoad'.t();
            }
        }
        catch (e) {
            console.error('Error loading shared conversation:', e);
            this.error = 'share.conversation.failedToLoad'.t();
        }
        finally {
            this.loading = false;
        }
    }
    handleDownload(file) {
        if (!file)
            return;
        try {
            const link = document.createElement('a');
            link.href = download_helper_1.DownloadHelper.getFilePath(file);
            link.download = `${file.filename}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        catch (e) {
            console.error('Error downloading image:', e);
        }
    }
    goToChat() {
        component_1.SiteMenu.goto.bind(this)('/ai/chat');
    }
    copyConversationLink() {
        const url = `${window.location.origin}/share/${this.uid}`;
        navigator.clipboard.writeText(url).then(() => {
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 2000);
        });
    }
    getFullTextPattern() {
        return {
            // Precise pattern that matches code blocks without consuming surrounding content
            pattern: /```(\w+)?\n?([\s\S]*?)```/g,
            replacement: (match, language, content) => {
                const normalizedLanguage = language ? this.normalizeLanguage(language) : 'plaintext';
                const codeId = voucher_code_generator_1.default.generate({ count: 1, length: 8 })[0].toLowerCase();
                // HTML encode the content to prevent browser from parsing it as HTML elements
                const encodedContent = this.escapeHtml(content);
                return `<code-screen class="share-preview" showTime="true" componentId="${codeId}" language="${normalizedLanguage}">${encodedContent}</code-screen>`;
            }
        };
    }
    escapeHtml(str) {
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
    normalizeLanguage(rawLanguage) {
        if (!rawLanguage)
            return 'plaintext';
        const normalized = rawLanguage.toLowerCase().trim();
        if (this.supportedLanguages.has(normalized)) {
            return normalized;
        }
        const aliases = {
            'node': 'javascript',
            'js': 'javascript',
            'ts': 'typescript',
            'py': 'python',
            'cs': 'csharp',
            'c++': 'cpp',
            'shell': 'bash',
            'sh': 'bash',
            'yml': 'yaml',
            'md': 'markdown'
        };
        if (aliases[normalized]) {
            return aliases[normalized];
        }
        if (/^[a-z][a-z0-9_-]*$/i.test(normalized)) {
            return normalized;
        }
        return 'plaintext';
    }
    /**
     * Replace line breaks with <br/> tags only outside of code blocks
     */
    replaceLineBreaksOutsideCodeBlocks(text) {
        // Find all code-screen elements (already processed code blocks)
        const codeScreenPattern = /<code-screen[^>]*>[\s\S]*?<\/code-screen>/g;
        const codeBlocks = [];
        const placeholders = [];
        // Extract code blocks and replace with placeholders
        let processedText = text.replace(codeScreenPattern, (match) => {
            const placeholder = `__CODE_BLOCK_${codeBlocks.length}__`;
            codeBlocks.push(match);
            placeholders.push(placeholder);
            return placeholder;
        });
        // Replace \n with <br/> in the remaining text (outside code blocks)
        processedText = processedText.replace(/\n/g, '<br/>');
        // Restore code blocks
        placeholders.forEach((placeholder, index) => {
            processedText = processedText.replace(placeholder, codeBlocks[index]);
        });
        return processedText;
    }
};
exports.ShareConvo = ShareConvo;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ShareConvo.prototype, "uid", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ShareConvo.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ShareConvo.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IConversation !== "undefined" && backendImport_1.IConversation) === "function" ? _a : Object)
], ShareConvo.prototype, "conversation", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ShareConvo.prototype, "messages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ShareConvo.prototype, "conversationTitle", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ShareConvo.prototype, "copied", void 0);
exports.ShareConvo = ShareConvo = __decorate([
    (0, client_1.RWSView)('shared-conversation', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ShareConvo);
ShareConvo.defineComponent();
